'use strict';

const _=require('pulsar-utils/dist-es6/_');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');let

IntervalService=class IntervalService extends BaseService{
static get $inject(){
return['dateService','timeZoneService'];
}

constructor(dateService,timeZoneService){
super();
this._dateService=dateService;
this._timeZoneService=timeZoneService;
}

get _localTimeZone(){
return this._timeZoneService.localTimeZone;
}

_getPointIntervalFromNow(){
let now=this._dateService.now();
return TimeInterval.fromPoint(now);
}

get today(){
return this._getPointIntervalFromNow().expandToRoundTarget('day',this._localTimeZone);
}

get todayForDisplay(){
return this._toDisplay(this.today);
}

get thisWeek(){
return this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone);
}

get thisWeekForDisplay(){
return this._toDisplay(this.thisWeek);
}

get nextWeek(){
let start=this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone);
return start.shift('week',1,this._localTimeZone);
}

get nextWeekForDisplay(){
return this._toDisplay(this.nextWeek);
}

get nextFourWeeksIncludingToday(){
const _now=this._dateService.now();
const midnightLastNight=zonedMoment(_now,this._localTimeZone).startOf('day').toDate();
const fourWeeksAfterToday=zonedMoment(_now,this._localTimeZone).startOf('day').add(28,'days').toDate();
return TimeInterval.from(midnightLastNight).to(fourWeeksAfterToday);
}

get nextFourWeeksIncludingTodayForDisplay(){
return this._toDisplay(this.nextFourWeeksIncludingToday);
}

get lastFourWeeksIncludingToday(){
const _now=this._dateService.now();
const midnightTonight=zonedMoment(_now,this._localTimeZone).endOf('day').add(1,'millisecond').toDate();
const fourWeeksPriorToToday=zonedMoment(_now,this._localTimeZone).endOf('day').subtract(28,'days').toDate();
return TimeInterval.from(fourWeeksPriorToToday).to(midnightTonight);
}

get lastFourWeeksIncludingTodayForDisplay(){
return this._toDisplay(this.lastFourWeeksIncludingToday);
}

get lastWeek(){
let start=this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone);
return start.shift('week',-1,this._localTimeZone);
}

get lastWeekForDisplay(){
return this._toDisplay(this.lastWeek);
}

get thisMonth(){
return this._getPointIntervalFromNow().expandToRoundTarget('month',this._localTimeZone);
}

get thisMonthForDisplay(){
return this._toDisplay(this.thisMonth);
}

get lastMonth(){
let start=this._getPointIntervalFromNow().expandToRoundTarget('month',this._localTimeZone);
return start.shift('month',-1,this._localTimeZone);
}

get lastMonthForDisplay(){
return this._toDisplay(this.lastMonth);
}

get nextMonth(){
let start=this._getPointIntervalFromNow().expandToRoundTarget('month',this._localTimeZone);
return start.shift('month',1,this._localTimeZone);
}

get nextMonthForDisplay(){
return this._toDisplay(this.nextMonth);
}

get previousFourWeeksAndWeekToDate(){
const _now=this._dateService.now();
const fourWeeksPriorToLastSunday=zonedMoment(_now,this._localTimeZone).startOf('week').subtract(28,'days').toDate();
const midnightTonight=zonedMoment(_now,this._localTimeZone).endOf('day').add(1,'millisecond').toDate();

return TimeInterval.from(fourWeeksPriorToLastSunday).to(midnightTonight);
}

get previousFourWeeksAndWeekToDateForDisplay(){
return this._toDisplay(this.previousFourWeeksAndWeekToDate);
}

_toDisplay(interval){
return new TimeInterval(interval.start,interval.end.getTime()-1);
}

getMonthlyLookbackIntervalIncludingCurrentDayFor(timezone,totalMonths){
_.ensureInstanceOf('string',timezone);
_.ensureInstanceOf('number',totalMonths);

if(totalMonths<=0){
throw new Error('Unexpected totalMonths');
}

const nowAsMoment=zonedMoment(this._dateService.now(),timezone);




return TimeInterval.
from(nowAsMoment.clone().subtract(totalMonths-1,'months').startOf('month').toDate()).
to(nowAsMoment.clone().endOf('day').toDate());
}

getSurroundingQuartersFor(date,timezone=this._localTimeZone){
const currentCalendarDay=CalendarDay.calendarDayFor({time:date,timezone:this._localTimeZone});
const[currentYear,currentMonth,currentDay]=currentCalendarDay.toString().split(/-/g).map(n=>parseInt(n,10));

const currentQuarter=_getQuarterForMonth(currentMonth);

return{
previous:currentQuarter===1?
_getAsCalendarRange(currentYear-1,4).asTimeInterval(timezone):
_getAsCalendarRange(currentYear,currentQuarter-1).asTimeInterval(timezone),

current:_getAsCalendarRange(currentYear,currentQuarter).asTimeInterval(timezone),

next:currentQuarter===4?
_getAsCalendarRange(currentYear+1,1).asTimeInterval(timezone):
_getAsCalendarRange(currentYear,currentQuarter+1).asTimeInterval(timezone)};

}};


const _getQuarterForMonth=month=>{
if(month<=3){
return 1;
}else if(month<=6){
return 2;
}else if(month<=9){
return 3;
}

return 4;
};

const _getStartDayForQuarter=(year,quarter)=>{
switch(quarter){
case 1:
return`${year}-01-01`;
case 2:
return`${year}-04-01`;
case 3:
return`${year}-07-01`;
case 4:
return`${year}-10-01`;}


throw new Error(`Got invalid quarter number: ${quarter}`);
};


const _getAsCalendarRange=(year,quarter)=>{
let nextYear=year;
let nextQuarter=quarter+1;
if(nextQuarter>4){
nextQuarter=1;
nextYear++;
}

return new CalendarRange(_getStartDayForQuarter(year,quarter),_getStartDayForQuarter(nextYear,nextQuarter));
};

module.exports=IntervalService;
//# sourceMappingURL=intervalService.js.map
